import React from 'react';
import { Typography, TypographyProps } from '@mui/material';
import dayjs from 'dayjs';

interface PeriodLabelProps extends TypographyProps {
  start: string;
  end: string;
}

const PeriodLabel: React.FC<PeriodLabelProps> = ({ start, end, ...typographyProps }) => {
  const formattedStart = dayjs(start).format('M/D/YY');
  const formattedEnd = dayjs(end).format('M/D/YY');

  return (
    <Typography {...typographyProps}>
      Period: {formattedStart} - {formattedEnd}
    </Typography>
  );
};

export default PeriodLabel;
